import cn from 'classnames';

import { IConDefaultType } from '..';

export enum BubbleChatRoundLogoIconVariant {
  DEFAULT = 'default',
  DISABLE = 'disable',
}

export interface IBubbleChatRoundLogoIconProps extends IConDefaultType {
  variant?: BubbleChatRoundLogoIconVariant;
}

function BubbleChatRoundLogoIcon({
  color,
  className,
  size = 28,
  rotate,
  flip,
  variant = BubbleChatRoundLogoIconVariant.DEFAULT,
}: IBubbleChatRoundLogoIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      {variant === BubbleChatRoundLogoIconVariant.DEFAULT && (
        <svg width={size} height={size} viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14" cy="14.5996" r="14" fill="#00C3DD" />
          <path
            d="M14 6.19922C18.6317 6.19922 22.4004 9.96797 22.4004 14.5996C22.4003 19.2312 18.6317 23 14 23C12.665 23 11.3859 22.693 10.1982 22.0889C10.088 22.0445 9.98446 22.0225 9.87305 22.0225C9.5946 22.0225 9.26415 22.1607 8.6416 22.4365L8.19434 22.6318C8.13758 22.6542 8.03865 22.6855 7.94434 22.6855C7.60639 22.6855 7.33128 22.4111 7.33105 22.0732C7.33105 22.0443 7.33158 22.023 7.36426 21.8613L7.40625 21.6445C7.66718 20.3241 7.67121 20.2378 7.40918 19.8037C6.22576 18.3072 5.59964 16.5082 5.59961 14.5996C5.59961 9.96797 9.36829 6.19922 14 6.19922ZM12.6152 14.9756C12.6155 15.741 13.2365 16.3621 14.002 16.3623C14.7676 16.3623 15.3894 15.7411 15.3896 14.9756H12.6152ZM10.0303 13.5879C9.45273 13.5881 8.98463 14.0563 8.98438 14.6338C8.98438 15.2115 9.45257 15.6804 10.0303 15.6807C10.6081 15.6806 11.0771 15.2116 11.0771 14.6338C11.0769 14.0561 10.608 13.5879 10.0303 13.5879ZM17.9736 13.5879C17.3959 13.5879 16.927 14.0561 16.9268 14.6338C16.9268 15.2117 17.3957 15.6807 17.9736 15.6807C18.5513 15.6804 19.0195 15.2115 19.0195 14.6338C19.0193 14.0563 18.5511 13.5882 17.9736 13.5879Z"
            fill="white"
          />
        </svg>
      )}
      {variant === BubbleChatRoundLogoIconVariant.DISABLE && (
        <svg width={size} height={size} viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="14" cy="14.5996" r="14" fill="#BCBCBC" />
          <path
            d="M14 6.19922C18.6314 6.19943 22.3992 9.96733 22.3994 14.5986C22.3994 19.2301 18.6315 22.9988 14 22.999C12.6649 22.999 11.385 22.6931 10.1973 22.0889C10.0869 22.0444 9.9836 22.0215 9.87207 22.0215C9.59373 22.0216 9.26374 22.1599 8.6416 22.4355C8.50407 22.4966 8.35563 22.5625 8.19434 22.6318L8.19336 22.6309C8.13665 22.6532 8.03844 22.6854 7.94434 22.6855C7.60625 22.6855 7.33105 22.4103 7.33105 22.0723C7.33105 22.0434 7.33065 22.0218 7.36328 21.8604L7.40625 21.6436C7.66708 20.3236 7.67018 20.2377 7.4082 19.8037C6.22475 18.3071 5.59961 16.5073 5.59961 14.5986C5.59985 9.9672 9.36843 6.19922 14 6.19922ZM12.6133 14.9727C12.6133 15.7384 13.2342 16.3593 14 16.3594C14.7657 16.3592 15.3867 15.7383 15.3867 14.9727H12.6133ZM10.0293 13.5859C9.4517 13.5859 8.9829 14.0544 8.98242 14.6318C8.98242 15.2097 9.4514 15.6787 10.0293 15.6787C10.6069 15.6783 11.0752 15.2095 11.0752 14.6318C11.0747 14.0546 10.6066 13.5863 10.0293 13.5859ZM17.9717 13.5859C17.3939 13.5859 16.925 14.0551 16.9248 14.6328C16.9251 15.2105 17.3939 15.6787 17.9717 15.6787C18.5491 15.6783 19.0173 15.2102 19.0176 14.6328C19.0173 14.0554 18.5491 13.5863 17.9717 13.5859Z"
            fill="white"
          />
        </svg>
      )}
    </i>
  );
}

export default BubbleChatRoundLogoIcon;
